<script>
  export let scale = 1;
  export let color = "#323232";
</script>

<svg width={40 * scale} height={40 * scale} viewBox="-12 -12 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill={color} d="M9.75 4.70093C10.75 5.27828 10.75 6.72166 9.75 7.29901L2.25 11.6291C1.25 12.2065 0 11.4848 0 10.3301V1.66984C0 0.515139 1.25 -0.206548 2.25 0.370802L9.75 4.70093Z" />
</svg>
